import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import React, { useCallback } from "react";
import styled from "@emotion/styled";
import { EpisodeSlider } from "./episodeList";
import _ from "lodash";
import { FOCUS_CONFIG, FOCUS_BORDER } from "../../config/focusStyles";
import { useInputMode } from "../../utils/hooks/useInputMode";

/**
 * Season Selector Button - styled component
 * Selected: Red background + white text
 * Focused: White background + red text
 */
var SeasonButton = styled.button`
  padding: 16px 32px;
  margin-left: 16px;
  font-family: "Anjoman Max FN", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  border: ${FOCUS_BORDER.inactive};
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  outline: none;

  /* Default state */
  background: rgba(255, 255, 255, 0.1);
  color: #bfbfbf;
  border-color: rgba(255, 255, 255, 0.2);

  /* Selected state: Red background + white text */
  ${(props) =>
    props.isSelected &&
    !props.isFocused &&
    `
    background: linear-gradient(135deg, #801313, #600F0F);
    -webkit-linear-gradient(135deg, #801313, #600F0F);
    color: #ffffff;
    border-color: #801313;
    font-weight: 700;
  `}

  /* Focused state: White background + red text */
  ${(props) =>
    props.isFocused &&
    `
    background: #ffffff;
    color: ${FOCUS_CONFIG.color};
    border-color: #ffffff;
    font-weight: 700;
    -webkit-box-shadow: 0 0 12px rgba(255, 255, 255, 0.4);
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.4);
  `}

  &:hover {
    background: #ffffff;
    color: ${FOCUS_CONFIG.color};
    border-color: #ffffff;
  }
`;

var SeasonsContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  margin-bottom: 2rem;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  z-index: 10;
  position: relative;
`;

var SeasonSelector = function SeasonSelector(props) {
  var selected = props.selected;
  var seasonKey = props.seasonKey;
  var onEnterPress = props.onEnterPress;
  var onFocus = props.onFocus;

  var focusResult = useFocusable({
    onEnterPress: onEnterPress,
    onFocus: onFocus,
  });
  var focused = focusResult.focused;
  var ref = focusResult.ref;
  var focusSelf = focusResult.focusSelf;

  var inputModeResult = useInputMode();
  var setMouseFocus = inputModeResult.setMouseFocus;
  var handleMouseEnter = useCallback(function () {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return React.createElement(SeasonButton, {
    ref: ref,
    onClick: onEnterPress,
    onMouseEnter: handleMouseEnter,
    isSelected: selected,
    isFocused: focused,
    type: "button",
  }, "فصل " + seasonKey);
};

var SeriesEpisodes = function SeriesEpisodes(props) {
  var seasons = props.seasons;
  var slug = props.slug;
  var onFocus = props.onFocus;
  var movie = props.movie;

  var selectedSeasonState = React.useState(1);
  var selectedSeason = selectedSeasonState[0];
  var setSelectedSeason = selectedSeasonState[1];

  var groupedEpisodes = _.groupBy(seasons, "seasonNumber");
  var seasonDetail = Object.keys(groupedEpisodes).map(function (key) {
    var obj = {};
    obj[key] = groupedEpisodes[key];
    return obj;
  });

  return React.createElement(React.Fragment, null,
    React.createElement(SeasonsContainer, null,
      seasonDetail.map(function (season, index) {
        var seasonKey = Object.keys(season)[0];
        return React.createElement(SeasonSelector, {
          season: season,
          key: "episode_" + index,
          selected: selectedSeason == seasonKey,
          seasonKey: seasonKey,
          onEnterPress: function () {
            setSelectedSeason(seasonKey);
          },
          onFocus: onFocus,
        });
      })
    ),
    React.createElement(EpisodeSlider, {
      movies: groupedEpisodes[selectedSeason],
      slug: slug,
      onFocus: onFocus,
      movie: movie,
    })
  );
};

export default SeriesEpisodes;
